import i18n from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import {initReactI18next} from "react-i18next";
import {TRANSLATIONS_EN} from "./en";


i18n.use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            "en-US": {
                translation: TRANSLATIONS_EN
            }
        },
        fallbackLng: "en-US",
    }).then();
